module.exports = __webpack_public_path__ + "img/Claudia Miyar.f831b612.jpg";